/*
 * THE GREETING, ONCE.
 *
 * The composer had a blue-gradient greeting and the chat surface had a grey sentence, so pressing
 * AI and landing in a fresh conversation showed helper text where the product's own welcome should
 * be — the panel looked unstyled next to the home hero it is supposed to match. They were two
 * renderings of the same moment, which is the same shape of bug as the sub-agent transcript: a
 * second implementation of one thing, drifting.
 *
 * So the markup and its styling live here and both surfaces import them. The gradient is the home
 * hero's, deliberately, so the whole product reads as one thing.
 */
import { html, css } from 'lit';
import { t } from '../i18n';
import { pickGreeting } from './greeting';
/** The welcome block: the rotating greeting plus its subtitle. */
export function greetingView(userName, seed) {
    const g = pickGreeting({ name: userName, hour: new Date().getHours(), seed });
    return html `
    <div class="welcome">
      <!-- Narrowed on "name": the named keys require an interpolation the anonymous ones forbid,
           and the typed t() enforces exactly that. (No backticks in here - inside a tagged
           template one would close the literal.) -->
      <h1 class="hi">${g.name === null ? t(g.key) : t(g.key, { name: g.name })}</h1>
      <p class="sub">${t('ai.composerSub')}</p>
    </div>
  `;
}
/** Styling for greetingView. Imported into each host's static styles. */
export const greetingCss = css `
  /* The greeting is the majority of an empty panel, deliberately: empty space above a composer is
     not waste, it is what makes the composer the subject. */
  .welcome {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 20px 20px;
    text-align: center;
  }
  .hi {
    margin: 0;
    font-size: 21px;
    font-weight: 600;
    line-height: 1.25;
    /* The app's own gradient on the app's own greeting - the same treatment the home hero uses,
       so the two read as one product. Clipped to the text box, not the row. */
    background: linear-gradient(135deg, #1652c9, #2491db 55%, #6fb2f4);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    width: fit-content;
    max-width: 100%;
  }
  .sub {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-secondary);
    max-width: 30ch;
  }
`;
//# sourceMappingURL=greeting-view.js.map